export const searchArticleInitialState = {
  filters: {
    title: "",
    category: "",
    categoryNames: "",
  },
  currentPage: 1,
  totalPages: 1,
  allArticleList: [],
  isArticleListLoading: false,
};

export const searchArticleReducer = (state, action) => {
  switch (action.type) {
    case "SET_ARTICLE_FILTERS":
      return {
        ...state,
        filters: { ...state.filters, ...action.payload },
        currentPage: 1, // reset to page 1 when filters change
      };
    case "SET_ARTICLE_PAGE":
      return { ...state, currentPage: action.payload };
    case "SET_ARTICLE_DATA":
      return {
        ...state,
        allArticleList: action.payload.data,
        totalPages: action.payload.totalPages,
        isArticleListLoading: false,
      };
    case "SET_ARTICLE_LOADING":
      return { ...state, isArticleListLoading: action.payload };
    case "RESET_ARTICLE_FILTERS":
      return {
        ...searchArticleInitialState,
      };
    default:
      return state;
  }
};
